import React, { Component, ReactNode } from 'react';

export class ScrollTopComponent extends Component {
  /**
   * Bind the scroll event
   */
  public componentDidMount(): void {
    window.addEventListener('scroll', this.scrollListener);
  }

  /**
   * Display the icon depending on the scroll distance
   */
  public scrollListener(): void {
    let scrollTop = $(window).scrollTop();
    const $el = $('.scrollTop');
    if (scrollTop > 600){
      if (!$el.is(':visible')) {
        $el.fadeIn();
      }
    } else {
      if ($el.is(':visible')) {
        $el.fadeOut();
      }
    }
  }

  /**
   * Scroll to the top of the page
   */
  public static scrollToTop(): void {
    $('html, body').animate({
      scrollTop: 0,
    }, 300);
  }

  /**
   * Render the component
   */
  public render(): ReactNode {
    return <i className="fa fa-angle-up scrollTop"
      onClick={(): void => ScrollTopComponent.scrollToTop()} style={{ display: 'none' }}/>;
  }
}
